<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Conference" />
            <ConfeRence />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ConfeRence from '../Conference/ConfeRence.vue';


export default {
    name: 'ConferencePage',
    components: {
        NavBar,
        PageTitle,
       ConfeRence,
        FooterComp,
    }
}
</script>